export const emailRegex = /^[a-zA-Z0-9._+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$/;
export const physicianNameRegex =
  /^\(?[A-Za-z](?:[A-Za-z\s.\-()]*[A-Za-z])?\)?$/;
export const personNameRegex = /^[A-Za-z](?:[A-Za-z\s-]*[A-Za-z])?$/;
export const numAlphabetOnlyRegex = /^[A-Za-z0-9]*$/;
export const anyCharacters = /^[!-~]*$/;
export const phoneFaxFormat = /^\([1-9]\d{2}\) \d{3}-\d{4}$/;
export const alphabetCountyRegex = /^[A-Za-zñáéíóúü\s]*[A-Za-z][A-Za-z\s]*$/;
export const alphabetRegex = /^[A-Za-z\s]*[A-Za-z][A-Za-z\s]*$/;
export const numberOnlyRegex = /^\d+$/;
export const cityFieldRegex = /^[A-Za-z]+([ .]+[A-Za-z]+)*$/;
export const patientNameRegex = /^[A-Za-z0-9_\-'.]+( [A-Za-z0-9_\-'.]+)*$/;